<template>
  <v-container id="home" class="full-height">
    <v-content class="grid-flex-column">
      <div class="proposta">
        <div class="add-proposta">
          <!-- Container -->
          <v-container
            fluid
            grid-list-xl
            style="overflow-x: hidden"
            v-if="!isStep5Edit"
            class="container-proposta"
          >
            <!-- Alert -->
            <v-flex xs12>
              <form-alert
                :type="alertText.type"
                :message="alertText.message"
                @close="closeFormAlert"
              ></form-alert>
            </v-flex>
            <!-- ./Alert -->

            <!-- Puzzle Etapas -->
            <v-layout row wrap>
              <v-flex xs12>
                <jns-step-puzzle
                  :step-user-is="step"
                  :steps="formSteps"
                  @click="changeStep"
                ></jns-step-puzzle>
              </v-flex>
            </v-layout>
            <!-- ./Puzzle Etapas -->

            <!-- Etapas -->
            <v-layout row wrap class="white_background no-gutter">
              <!-- ****Passo 1 - Segurado, Modalidade, Vigência, Importância Segurada -->
              <v-content class="content_body" v-if="step == 1">
                <h2 class="titulo-proposta">Comece sua cotação</h2>
                <p class="info-proposta">
                  Precisamos de algumas informações referente ao processo que
                  deseja garantir.
                </p>
                <v-form v-model="validPasso1" class="form-proposta">
                  <div class="box-combo-modalidades">
                    <v-select
                      v-model="comboModalidades"
                      :rules="modalidadesRules"
                      label="Modalidade *"
                      :items="itemsModalidade"
                      item-value="id_produto"
                      item-text="descricao"
                      class="combo-modalidades jns-input"
                      placeholder=" "
                      outlined
                    >
                    </v-select>
                  </div>

                  <!-- Ínicio Segurado -->
                  <div class="box-segurado">
                    <label class="font-weight-black caption"
                      >Escolha o tipo de segurado</label
                    >

                    <div class="box-buttons-tipo">
                      <v-btn
                        class="jns-button blue-button"
                        v-for="(text, index) in [
                          'Pessoa Jurídica',
                          'Pessoa Física',
                        ]"
                        :key="index"
                        :class="{ active: tipoSegurado == index + 1 }"
                        :value="index + 1"
                        @click="selectInsuredType($event)"
                      >
                        {{ text }}
                        <v-icon v-if="tipoSegurado == index + 1" class
                          >check_circle_alt</v-icon
                        >
                      </v-btn>
                    </div>

                    <div class="input-segurado" v-if="tipoSegurado <= 2">
                      <v-flex>
                        <v-text-field
                          :placeholder="'Pesquisar'"
                          append-icon="search"
                          :label="textBoxlabel"
                          :rules="[rules.obrigatorio, rules.cpfCnpjInvalido]"
                          @click:append="getInsure"
                          v-model="seguradoDocumento"
                          v-mask="textBoxMask"
                          @keypress="inputActive()"
                          @blur="inputActive()"
                          @focus="focus()"
                          @keyup.enter="getInsure()"
                          class="jns-input"
                        ></v-text-field>
                      </v-flex>

                      <div class="msg_cpf_segurado" v-if="showMsgCpf">
                        <p>
                          Conforme Art. 2º do Ato Conjunto n°1 de 16 de Outubro
                          de 2019, o Segurado das apólices de Seguro Garantia de
                          Depósito Recursal deve ser o reclamante ou o exequente
                          e não mais a Vara ou Tribunal.
                        </p>
                      </div>
                    </div>

                    <div class="segurado-info" v-if="insured.info">
                      <person-info-box
                        :info="insured.info"
                        :show-unselect-button="false"
                        :showAddressChangeButton="
                          insured.info.tipo_pessoa == 'FISICA'
                        "
                        :lograduroCompacto="false"
                        @salvarEndereco="salvarEndereco"
                      ></person-info-box>
                    </div>
                  </div>
                  <!-- Fim Segurado -->
                  <p
                    class="msg-informa"
                    v-if="!(comboModalidades.length < 0) && !seguradoLoad"
                  >
                    Informar a modalidade e segurado da apólice para prosseguir
                    com a cotação do seguro.
                  </p>

                  <div
                    class="box-recursal"
                    v-if="comboModalidades && seguradoLoad && !taxaIsEmpty"
                  >
                    <template>
                      <v-text-field
                        class="jns-input valor-recurso"
                        label="Valor do Recurso *"
                        v-model="valorRecurso"
                        v-money="moneyConfig"
                        placeholder=" "
                        @input="calculaImportancia"
                        :rules="[valorRecursoRules]"
                        required
                        @blur="calculaPremioApi"
                        @focus="limpaPremio"
                      ></v-text-field>

                      <div class="importancia-segurada">
                        <v-text-field
                          style="border-radius: 4px 0 0 4px"
                          class="jns-input"
                          label="Importância Segurada *"
                          :value="
                            importanciaSeguradaFormatada == null
                              ? 'R$0,00'
                              : importanciaSeguradaFormatada
                          "
                          placeholder=" "
                          :disabled="recursal"
                          autofocus
                        ></v-text-field>
                        <div class="box-icon">
                          <v-icon
                            class="icon_recursal"
                            @mouseover="showTooltipRecursal = true"
                            @mouseleave="showTooltipRecursal = false"
                            >help</v-icon
                          >
                        </div>

                        <div class="msg_recursal" v-if="showTooltipRecursal">
                          Conforme Art. 3° do Ato Conjunto n°1, para o seguro
                          garantia para Depósito Recursal, o valor da
                          Importância Segurada deverá ser igual ao montante da
                          condenação, acrescido de 30%.
                        </div>
                      </div>
                      <!--./ valor recursal -->

                      <v-menu
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        class="inicio-vigencia"
                      >
                        <v-text-field
                          slot="activator"
                          class="jns-input jns-datepicker"
                          label="Início Vigência *"
                          append-icon="event"
                          placeholder=" "
                          v-model="inicioVigenciaFormatted"
                          :rules="iVigenciaRules"
                          readonly
                          required
                          @blur="calculaPremioApi"
                          @focus="limpaPremio"
                        ></v-text-field>
                        <v-date-picker
                          v-model="inicioVigencia"
                          no-title
                          scrollable
                          locale="pt-BR"
                          actions
                        ></v-date-picker>
                      </v-menu>

                      <v-select
                        v-if="
                          modalidadeResumo.tipo_vigencia === 'Prazo' ||
                            modalidadeResumo.tipo_vigencia == null
                        "
                        v-model="prazoAno"
                        :rules="[rules.obrigatorio]"
                        label="Prazo em anos"
                        :items="anos"
                        :item-value="'index'"
                        :item-text="'description'"
                        class="jns-input prazo-ano"
                        placeholder=" "
                        outlined
                        :disabled="!inicioVigenciaFormatted"
                        required
                        @blur="calculaPremioApi"
                        @focus="limpaPremio"
                      ></v-select>

                      <v-text-field
                        v-if="modalidadeResumo.tipo_vigencia === 'Período'"
                        v-model="prazoDia"
                        :rules="[rules.obrigatorio, minDias, maxDias]"
                        class="jns-input prazo-dia"
                        label="Prazo Dias"
                        v-mask="['#####']"
                        placeholder=" "
                        :disabled="!inicioVigenciaFormatted"
                        required
                        @blur="calculaPremioApi"
                        @focus="limpaPremio"
                      ></v-text-field>

                      <v-menu
                        v-if="modalidadeResumo.tipo_vigencia === 'Período'"
                        lazy
                        transition="scale-transition"
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        class="final-vigencia"
                      >
                        <v-text-field
                          slot="activator"
                          class="jns-input jns-datepicker"
                          v-model="fimVigenciaFormatted"
                          label="Fim Vigência *"
                          append-icon="event"
                          placeholder=" "
                          :rules="fVigenciaRules"
                          readonly
                          disabled
                          required
                        ></v-text-field>
                      </v-menu>
                    </template>
                  </div>
                  <div>
                    <v-checkbox
                      v-model="agravamento"
                      label="Agravamento"
                      disabled
                      style="margin: 0"
                    ></v-checkbox>
                  </div>
                  <div id="bottom"></div>
                </v-form>
              </v-content>
              <!-- ./****Passo 1 - Segurado, Modalidade, Vigência, Importância Segurada -->

              <!-- ****Passo 2 - Objeto Seguro -->
              <v-content class="content_body" v-if="step == 2">
                <h2 class="titulo">Objeto</h2>

                <v-form v-model="validPasso2" class="form-proposta-2">
                  <div
                    :class="TAGs.length > 3 ? 'box-objeto-full' : 'box-objeto'"
                  >
                    <div
                      v-for="(tag, index) in TAGs"
                      :key="index"
                      :class="
                        TAGs.length > 3 ? 'tags-input-full' : 'tags-input'
                      "
                    >
                      <v-text-field
                        class="jns-input"
                        :label="`${tag.label} *`"
                        v-model="tag.value"
                        placeholder=" "
                        @keyup="changeTagPlaceholderContent($event, tag)"
                        :rules="[rules.obrigatorio]"
                        required
                      ></v-text-field>
                    </div>
                  </div>
                </v-form>
              </v-content>
              <!-- ./****Passo 2 - Objeto Seguro -->

              <!-- ****Passo 3 - Prêmio -->
              <premio-comissao
                v-if="step == 3"
                :idProposta="this.idConsultaProposta.id_proposta"
                :idProduto="this.idConsultaProposta.id_produto"
                :proposta="proposta"
                @showQuestionamento="showQuestionamento"
                @emitProposalValues="definePolice"
                @emitGetMinuta="getMinuta"
                @desistir="desistir"
                @abrirModalTermosAceite="abrirModalTermosAceite"
              ></premio-comissao>
              <!-- ./****Passo 3 - Prêmio -->
            </v-layout>
            <!-- ./Etapas -->
          </v-container>
          <!-- Container -->

          <!-- Footer -->
          <v-footer v-if="step < 3 && !isStep5Edit" class="proposta__footer">
            <v-btn
              class="jns-button width-auto white-button"
              @click="desistir()"
              >Desistir</v-btn
            >

            <v-spacer></v-spacer>

            <div>
              <v-btn
                class="jns-button width-auto yellow-button"
                @click="processTheRequest()"
                :disabled="checkIfDisabled(step)"
                v-if="step === 2"
              >
                {{ labelButtonEtapas(step) }}
                <v-icon>{{ step === 3 ? "done" : "arrow_right_alt" }}</v-icon>
              </v-btn>

              <v-btn
                class="jns-button width-auto yellow-button"
                @click="goToNextStep(step)"
                :disabled="checkIfDisabled(step)"
                v-else
              >
                {{ labelButtonEtapas(step) }}
                <v-icon>{{ step === 3 ? "done" : "arrow_right_alt" }}</v-icon>
              </v-btn>
            </div>
          </v-footer>

          <!-- *************MODAIS -->
          <v-dialog v-model="successModal" :max-width="'640'">
            <base-modal>
              <h2 class="headline">Proposta salva com sucesso</h2>
              <p class="pt-2 pb-4" v-html="successReturn"></p>
              <v-layout row wrap>
                <v-flex xs4 offset-xs8>
                  <button
                    class="button jns-button yellow-button"
                    @click="successReturnClick()"
                  >
                    OK
                  </button>
                </v-flex>
              </v-layout>
            </base-modal>
          </v-dialog>

          <v-dialog v-model="semProdutos" :max-width="'640'">
            <base-modal>
              <h2 class="headline">Aviso</h2>
              <p class="pt-2 pb-4">
                O tomador não possui produto habilitado para o tipo de segurado
                selecionado.
              </p>
              <v-layout row wrap>
                <v-flex xs4 offset-xs8>
                  <button
                    class="button jns-button yellow-button"
                    @click="semProdutosClick()"
                  >
                    OK
                  </button>
                </v-flex>
              </v-layout>
            </base-modal>
          </v-dialog>

          <v-dialog v-model="validateLimitModal" :max-width="'640'">
            <base-modal>
              <h2 class="headline">Limite indisponível</h2>
              <p class="pt-2 pb-4">
                O tomador não possui limite de crédito disponível para esta
                operação!
              </p>
              <v-layout row wrap>
                <v-flex xs4 offset-xs8>
                  <button
                    class="button jns-button yellow-button"
                    @click="validateLimitModalClick()"
                  >
                    OK
                  </button>
                </v-flex>
              </v-layout>
            </base-modal>
          </v-dialog>

          <!-- Modal desistência passo 5-->
          <v-dialog v-model="modalDesistir" :max-width="'640'">
            <div class="modal">
              <h2 class="headline">Informe o motivo da desistência</h2>
              <div>
                <v-select
                  class="form-select-box"
                  label="Motivo"
                  v-model="id_motivo"
                  placeholder="Motivo "
                  :rules="[(v) => !!v || 'Este campo deve ser preenchido!']"
                  :items="motivos"
                  :item-value="'id'"
                  :item-text="'descricao'"
                ></v-select>

                <v-textarea
                  class="jns-input"
                  label="Observações"
                  v-model="observacao"
                  placeholder=" "
                ></v-textarea>

                <div class="buttons-desistir">
                  <v-btn
                    class="button jns-button yellow-button"
                    @click="quitProposal()"
                    >OK</v-btn
                  >

                  <v-btn
                    class="button jns-button yellow-button"
                    @click="modalDesistir = false"
                    >Cancelar</v-btn
                  >
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- ./Modal desistência -->

          <!-- Modal desistência -->
          <v-dialog v-model="confirmQuitModal" :max-width="'640'">
            <base-modal>
              <h2 class="headline">Certeza que deseja desistir?</h2>
              <p class="pt-2 pb-4">Todos os dados de proposta serão perdidos</p>
              <v-layout row wrap>
                <v-flex xs4></v-flex>
                <v-flex xs4>
                  <v-btn
                    class="button jns-button yellow-button"
                    @click="quitProposal()"
                    >OK</v-btn
                  >
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    class="button jns-button yellow-button"
                    @click="confirmQuitModal = false"
                    >Cancelar</v-btn
                  >
                </v-flex>
              </v-layout>
            </base-modal>
          </v-dialog>
          <!-- ./Modal desistência -->

          <v-dialog v-model="confirmParticipantDelete" :max-width="'640'">
            <base-modal>
              <h2 class="headline">
                Certeza que deseja deletar esse participante?
              </h2>
              <v-layout row wrap>
                <v-flex xs4>
                  <button
                    class="button jns-button yellow-button"
                    @click="
                      takerParticipants.splice(participantToBeDeleted, 1);
                      participantToBeDeleted = false;
                      confirmParticipantDelete = false;
                    "
                  >
                    OK
                  </button>
                </v-flex>
                <v-flex xs4>
                  <button
                    class="button jns-button white-button"
                    @click="
                      participantToBeDeleted = false;
                      confirmParticipantDelete = false;
                    "
                  >
                    Cancelar
                  </button>
                </v-flex>
              </v-layout>
            </base-modal>
          </v-dialog>

          <!-- Modal de questionamento -->
          <questionamento-component
            :questionamentoDialog="dialogQuestionamento"
            :questionamentoSucessoDialog="questionamentoSucessoModal"
            @send="sendQuestionamento"
            @close="dialogQuestionamento = false"
          />

          <!-- Modal CPF do Segurado -->
          <v-dialog
            v-model="modalNome"
            class="modal-new"
            :max-width="'640'"
            persistent
          >
            <base-modal>
              <h2 class="headline">Pessoa Física (Depósito Recursal)</h2>

              <v-form ref="novoSegurado" lazy-validation>
                <v-layout row wrap mt-3>
                  <v-flex xs12>
                    <v-text-field
                      class="jns-input"
                      label="Informe o nome"
                      v-model="insuredName"
                      placeholder="Nome do segurado"
                      :rules="[rules.obrigatorio]"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 pt-0 pb-2>
                    <h3>Endereço</h3>
                  </v-flex>
                </v-layout>

                <endereco-component
                  :endereco="insuredAddress"
                  :lograduroCompacto="false"
                  :numberRequired="false"
                  ref="formEnderecoComponent"
                ></endereco-component>
              </v-form>

              <v-layout row wrap>
                <v-flex xs6>
                  <button
                    class="jns-button ml-0 white-button"
                    @click="modalNome = false"
                  >
                    Cancelar
                  </button>
                </v-flex>
                <v-flex xs6>
                  <button
                    class="button jns-button yellow-button ml-0"
                    @click="salvarSegurado()"
                  >
                    Salvar
                  </button>
                </v-flex>
              </v-layout>
            </base-modal>
          </v-dialog>

          <!-- Modal Processando Solicitação -->
          <v-dialog
            v-model="dialogProcessandoSolicitacao"
            persistent
            max-width="700"
          >
            <base-modal>
              <processo-solicitacao-proposta
                :processSteps="this.processSteps"
                :processInExecution="this.processInExecution"
                :message="this.actualProcessStepErrorMessage"
                :processSuccess="this.processSuccess"
                :mostraBotaoAvancar="this.id_proposta && this.id_produto"
                :statusProposta="proposta.s"
                @goto="goto"
              ></processo-solicitacao-proposta>
            </base-modal>
          </v-dialog>

          <!-- Modal termos de aceite para emitir proposta -->
          <v-dialog
            v-model="dialogEmitirProposta"
            scrollable
            persistent
            max-height="600px"
            min-height="500px"
            max-width="800px"
          >
            <v-card class="px-3 pt-3">
              <v-card-text>
                <h2 class="headline">Termo de Aceite</h2>
                <div class="pt-2 pb-4">
                  <span
                    >Leia os termos para solicitar a emissão da proposta.</span
                  >
                </div>
                <p>{{ this.termos }}</p>
              </v-card-text>
              <v-card-actions>
                <v-checkbox v-model="aceitaTermos" color="blue">
                  <div slot="label">
                    Declaro que li e estou de acordo com os termos acima
                  </div>
                </v-checkbox>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      style="width: 130px"
                      class="jns-button width-auto white-button"
                      outline
                      round
                      @click="dialogEmitirProposta = false"
                      >Cancelar</v-btn
                    >
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      style="width: 150px"
                      class="jns-button width-auto yellow-button"
                      :dark="aceitaTermos"
                      round
                      :disabled="!aceitaTermos"
                      @click="emitirApolice"
                      >Solicitar</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- ./Modal termos de aceite para emitir proposta -->

          <!-- Modal para emitir proposta -->
          <v-dialog
            persistent
            v-model="dialogEmitindoProposta"
            max-height="600px"
            min-height="500px"
            max-width="500px"
          >
            <v-card class="px-3 pt-3">
              <v-card-text>
                <div
                  v-if="erroResponse.status == 0 && propostaEmitida == false"
                  class="my-3"
                >
                  <img
                    :src="
                      require('../../../assets/animations/loading-yellow.gif')
                    "
                    class="loading-animation"
                    alt
                  />
                  <h2 class="headline">Solicitando emissão da proposta</h2>
                  <p class="pt-2 pb-4">
                    Enviando os dados para emissão da proposta. Por favor, não
                    saia da tela...
                  </p>
                </div>
                <div v-else-if="propostaEmitida == true" class="my-5">
                  <h2 class="headline">Apólice emitida</h2>
                  <p class="pt-2 pb-4">
                    A proposta número {{ id_proposta }} foi emitida com sucesso!
                  </p>
                </div>
                <!--- reemissão de proposta com alteração de vigência -->
                <div v-else-if="erroResponse.data.code == 4051" class="mb-3">
                  <h2 class="headline">{{ erroResponse.data.title }}</h2>
                  <div class="pt-2 pb-4">{{ erroResponse.data.message }}</div>
                </div>

                <div v-else class="mb-3">
                  <h2 class="headline">{{ erroResponse.data.title }}</h2>
                  <p class="pt-2 pb-4">{{ erroResponse.data.message }}</p>
                  <p v-if="erroResponse.data.code == 4055" class="pt-2 pb-4">
                    <a :href="urlCliqueAqui">Clique aqui</a>
                  </p>
                </div>

                <v-layout row wrap v-if="erroResponse.data.details != null">
                  <v-flex xs4 class="pt-2 pb-4">
                    <p
                      class="see-details mb-0"
                      @click="toggleShowDetails()"
                      v-if="erroResponse.data.details != 'Sem detalhes'"
                    >
                      Ver detalhes
                      <v-btn icon>
                        <v-icon v-if="showDetails">keyboard_arrow_up</v-icon>
                        <v-icon v-if="!showDetails">keyboard_arrow_down</v-icon>
                      </v-btn>
                    </p>
                  </v-flex>
                  <v-fade-transition>
                    <v-flex xs12 v-if="showDetails">
                      <v-textarea
                        class="details"
                        outline
                        readonly
                        :value="erroResponse.data.details"
                      ></v-textarea>
                    </v-flex>
                  </v-fade-transition>
                </v-layout>
              </v-card-text>

              <v-card-actions v-if="erroResponse.mostraBtnAcao">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-btn
                      style="width: 100%; margin: 0 auto"
                      class="jns-button width-auto yellow-button"
                      round
                      @click="goto('timeline')"
                      >Detalhes da apólice</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
              <v-card-actions v-if="erroResponse.data.code == 4051">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      style="width: 95%"
                      class="jns-button width-auto yellow-button"
                      round
                      @click="emitirApolice({ alterarVigencia: true })"
                      >Aceito</v-btn
                    >
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      style="width: 95%"
                      class="jns-button width-auto yellow-button"
                      round
                      @click="goto('home')"
                      >Cancelar</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- ./Modal para emitir proposta -->

          <v-dialog fullscreen hide-overlay v-model="dialogAnaliseCredito">
            <v-card>
              <v-container grid-list-xl class="no-padding">
                <v-card-title class="ml-0 pl-0 pt-5 pb-4">
                  <h2>Análise de Crédito</h2>
                </v-card-title>

                <processo-analise-credito
                  v-if="dialogAnaliseCredito"
                  :item="
                    taker.tomador_credito ? taker.tomador_credito : taker.info
                  "
                  :pendencias="pendencias"
                  :route="'POST_PRE_ANALISE_CREDITO'"
                  :slug="slug"
                  @fecharAnaliseCreditoModal="fecharAnaliseCreditoModal"
                  @solicitarLimites="solicitarLimitesAnaliseCredito"
                ></processo-analise-credito>
              </v-container>
            </v-card>
          </v-dialog>
        </div>

        <div class="resumo-proposta">
          <proposta-resumo
            :corretor="dadosCorretor"
            :segurado="insured.info"
            :modalidade="modalidadeResumo.descricao"
            :valor_recurso="valorRecurso"
            :importancia_segurada="importanciaSegurada"
            :inicio_vigencia="inicioVigenciaFormatted"
            :valor_premio="valorPremio"
            :fim_vigencia="fimVigenciaFormatted"
            :fim_vigencia_ano="fimVigenciaYearFormatted"
            :vigencia_dia="prazoDia"
            :vigencia_ano="prazoAno"
            :tomador="me"
            :product="product"
            :taker="taker"
            :step="step"
            :TAGs="TAGs"
            :buscandoLimite="buscandoLimite"
            :msgErroBuscaLimite="msgErroBuscaLimite"
            :erroBuscaLimite="erroBuscaLimite"
            :taxa_empty="taxaIsEmpty"
            @emitGetMinuta="getMinuta"
          ></proposta-resumo>
        </div>
      </div>
    </v-content>
  </v-container>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
import PropostaMixin from "@/mixins/PropostaMixin";
import { isValidCnpj, isValidCpf, formatCNPJAndCPFNoMask,  isCNPJ, capitalize, formatDate, toMoneyString } from "@/libs/utils";
import PictureInput from "vue-picture-input";
import { upload } from "@/services/fake.file-upload.service";
import moment from "moment";
import PremioComissao from "@/router/views/Propostas/Passos/PremioComissao";
import { mapActions } from "vuex";
import axios from "axios";
import config from "@/../config";
import { VMoney } from "v-money";

export default {
  name: "Home",
  props: {
    toStep5: {
      type: Number,
      default: 5,
    },
  },
  components: {
    PremioComissao,
  },
  mixins: [ViewMixin, PropostaMixin],
  directives: { money: VMoney },
  data: () => ({
    params: {},
    menu: null,
    emBreveModal: false,
    moneyConfig: {},
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: " ",
      precision: 2,
      masked: false /* doesn't work with directive */,
    },
    formatCNPJAndCPFNoMask,
    toMoneyString,

    //Carregado no início do sistema
    taker: {
      stepType: 1,
    },
    itemsModalidade: [],
    dadosCorretor: null,

    //Início passo 1
    insured: {},
    validPasso1: false,

    //Segurado
    seguradoLoad: false,
    agravamento: true,
    showMsgCpf: false,
    rules: {
      obrigatorio: (value) => !!value || "Campo obrigatório.",
      cpfCnpjInvalido: (v) =>
        !!v && v.length > 14
          ? (!!v && isValidCnpj(v)) || "Número de documento inválido"
          : (!!v && isValidCpf(v)) || "Número de documento inválido",
    },
    seguradoDocumento: '',
    tipoSegurado: 1,
    seguradoRules: [
      v => !!v || 'O Campo segurado é obrigatório.',
    ],

    comboModalidades: '',
    modalidadeResumo: '',
    modalidadesRules: [
      v => !!v || 'O campo modalidade é obrigatório.',
    ],

    formatDate,
    inicioVigencia: "",
    inicioVigenciaFormatted: "",
    iVigenciaRules: [
      v => !!v || 'O campo ínicio vigência é obrigatório.',
    ],

    fimVigencia: "",
    fimVigenciaFormatted: "",
    fimVigenciaYearFormatted: "",
    fVigenciaRules: [
      v => !!v || 'O campo fim vigência é obrigatório.',
    ],

    prazoDia: "",

    valorRecurso: "",

    importanciaSegurada: "",
    importanciaSeguradaFormatada: "",
    valorPremio: "",
    taxa: null,
    taxaIsEmpty: true,

    recursal: true,
    showTooltipRecursal: false,
    prazoAno: 0,
    anos: [
      { index: 0, description: "Prazo" },
      { index: 3, description: "3 anos" },
      { index: 4, description: "4 anos" },
      { index: 5, description: "5 anos" },
    ],
    //Fim passo 1

    //Início passo 2
    validPasso2: false,
    idConsultaProposta: {},
    //Fim passo 2

    //Início passo 3
    validPasso3: false,
    //Fim passo 3

    formSteps: [
      { id: 1, number: "01", text: "Dados da Apólice" },
      { id: 2, number: "02", text: "Dados do Objeto Seguro" },
      { id: 3, number: "03", text: "Dados do Pagamento" },
    ],
    tomadorAnaliseCredito: undefined,
    development: true, //FIXME: COLOCAR FALSE AO ENVIAR PARA HOM/PRD
    modalNome: false,
    insuredName: "",
    idTomador: 0,
    proposta: false,
    erroBuscaLimite: false,
    bloqueiaErroBuscaLimite: false,
    msgErroBuscaLimite: "",
    limitesAgrupadosPorModalidade: {},
    buscandoLimite: false,
    buscandoLimiteModalidades: false,
    step: 1,
    lastTakerSearchWasCNPJ: false,
    lastInsuredSearchWasCNPJ: false,
    id_proposta: false,
    id_produto: false,
    tabDetalharProposta: "",
    limits: false,
    drawer: null,
    aceitaTermos: false,
    dialogEmitirProposta: false,
    limitsMenu: false,
    successModal: false,
    validateLimitModal: false,
    successReturn: false,
    participantToBeDeleted: false,
    confirmParticipantDelete: false,
    participanteModal: false,
    loadingFromBackendModal: false,
    confirmQuitModal: false,
    modalDesistir: false,
    dialogResumoProposta: false,
    dialogAnaliseCredito: false,
    stepCompleted: 0,
    selectedProductGroup: 0,
    selectedProduct: false,
    selectedAdditionalCoverages: [],
    selectedCoverages: [],
    productGroups: {},
    resumoProposta: {},
    showSelectTaker: false,
    showListToSelectInsured: false,
    completedTaker: false,
    takerFormValid: false,
    takerParticipants: [],
    takerResults: [],
    insuredResults: [],
    TAGs: [],
    foreignTaker: {},
    tagMenu: [],
    inicioVigenciaMenu: [],
    fimVigenciaMenu: [],
    prize: {},
    insuredFormValid: false,
    product: [],
    stepTitles: [
      "Tomador",
      "Segurado",
      "Modalidade",
      "Informações de Garantia",
      "Prêmio",
    ],
    insuredAddress:{},
    reloadParticipanteModal: true,
    dialogQuestionamento: false,
    questionamento: {
      body: {
        observacoes: "",
        documentos: [],
      },
    },
    isStep5Edit: false,
    mostraBtnQuestionamento: false,
    documentosData: [],
    questionamentoSucessoModal: false,
    id_motivo: 0,
    observacao: "",
    termos: "",
    motivos: [],
    toolTipLimitesIndisponiveis: false,
    toolTipBuscandoLimites: false,
    tipo_pessoa: "",
    semProdutos: false,
    idTomadorPesquisaLimites: 0,
    parameters: [],
    parametersTomador: {},
    dialogProcessandoSolicitacao: false,
    dialogEmitindoProposta: false,
    processInExecution: false,
    processSuccess: false,
    actualProcessStepErrorMessage: "",
    apolice: null,
    statusProposta: "",
    erroResponse: {
      status: 0,
      data: {},
      mostraBtnAcao: false,
    },
    propostaEmitida: false,
    urlCliqueAqui: "",
    processSteps: [
      {
        step: 1,
        display: true,
        status: "pending",
        text: "Salvando a proposta...",
        success_text: "Proposta n° arg criada com sucesso.",
        error_text: "Não foi possivel salvar a proposta.",
        details: null,
      },
      {
        step: 2,
        display: false,
        status: "pending",
        text: "Aprovação automática de cŕedito...",
        success_text: "Crédito aprovado automaticamente.",
        error_text: "Aprovação automática de crédito.",
        details: {
          recusado: "Proposta recusada pela análise automática de crédito.",
          corretor:
            "Prezado Corretor, o tomador passará por análise de crédito manual, favor prosseguir com anexo de documentação solicitada. Em breve retornamos com as condições de limites e taxas.",
          seguradora:
            "Prezado Corretor, o tomador passará por análise de crédito manual. Em breve retornamos com as condições de limites e taxas.",
        },
      },
      {
        step: 3,
        display: false,
        status: "pending",
        text: "Aprovação automática de subscrição...",
        success_text: "Subscrição aprovada automaticamente.",
        error_text: "Aprovação automática de subscrição.",
        details: {
          recusado: "Proposta recusada pela análise automática de subscrição.",
          corretor:
            "Necessário fornecer documentação complementar do Risco a ser garantido, e a proposta será direcionada para análise de subscrição.",
          seguradora: "A proposta será direcionada para análise de subscrição.",
        },
      },
      {
        step: 4,
        display: false,
        status: "pending",
        text: "Aprovação automática de resseguro...",
        success_text: "Resseguro aprovado automaticamente.",
        error_text: "Aprovação automática de resseguro.",
        details: {
          recusado: "Proposta recusada pela análise automática de resseguro.",
          corretor:
            "Necessário fornecer documentação complementar do Risco a ser garantido, e a proposta será direcionada para análise de resseguro.",
          seguradora: "A proposta será direcionada para análise de resseguro.",
        },
      },
    ],
    showDetails: false,
    isProcessing: false,
  }),

  created(){
    this.init();
  },

  computed: {

    pendencias() {

      let temPendencias = false;
      let maxImportanciaSegurada = null;

      if (
        this.productGroups[this.selectedProductGroup].id_grupo == "TRADICIONAL"
      )
        maxImportanciaSegurada = this.parametersTomador.valor_limite_is
          .tradicionais;
      else if (
        this.productGroups[this.selectedProductGroup].id_grupo == "FINANPRIVADO"
      )
        maxImportanciaSegurada = this.parametersTomador.valor_limite_is
          .pagamentos;
      else
        maxImportanciaSegurada = this.parametersTomador.valor_limite_is
          .judiciais;

      if (
        this.product &&
        this.product.coberturas &&
        this.product.coberturas.length
      )
        this.product.coberturas.forEach((produto) => {
          if (produto.importancia_segurada) {
            let importancia_segurada =
              typeof produto.importancia_segurada == "string"
                ? parseFloat(
                    produto.importancia_segurada
                      .replace("R$ ", "")
                      .replace(/\./g, "")
                      .replace(",", ".")
                  )
                : produto.importancia_segurada;

            if (maxImportanciaSegurada < importancia_segurada)
              temPendencias = true;
          }
        });
      return temPendencias ? this.parametersTomador.pendencias : [];
    },

    textBoxlabel() {
      if (this.insured) {
        switch (this.tipoSegurado.toString()) {
          case "1":
            return "Digite o CNPJ do segurado";
          case "2":
            return "Digite o CPF do segurado";
        }
      } else return "Digite o CNPJ do segurado";
    },

    textBoxMask() {
      if (this.insured) {
        switch (this.tipoSegurado.toString()) {
          case "1":
            return "##.###.###/####-##";
          case "2":
            return "###.###.###-##";
          default:
            "##.###.###/####-##";
        }
      } else return "##.###.###/####-##";
    },

    slug() {
      if (this.selectedProductGroup)
        return this.productGroups[this.selectedProductGroup].id_grupo;

      return false;
    },

    me() {
      return localStorage ? JSON.parse(localStorage.getItem("me")) : {};
    },
  },

  methods: {
    async salvarEndereco(endereco){
      let data;

      let payload = {
        document: this.insured.info.cnpj_cpf.replace(/[^\w\s]/gi, ""),
        id: this.insured.info.id,
        data: {
          tipo_pessoa: this.insured.info.tipo_pessoa,
          nome: this.insured.info.nome,
          endereco: endereco
        }
      };

        try {
          this.showLoadingIndicator();
          data = await this.$store.dispatch("UPDATE_INSURED_ADDRESS", payload);
        } catch (e) {
          if (e && e[0] && !e[0].ativo) {
            return this.handleInactivePersonError(e[0], "Segurado");
          }
          this.defaultHandlerError(e);
          return;
        } finally {
          this.modalNome = false;
          this.hideLoadingIndicator();
        }

        this.alertText = this.handleAlertText2(
          "Endereço atualizado com sucesso!"
        );

        this.insured.info = {...data, nome: data.nome.toUpperCase()};

        this.stepCompleted = 2;
        this.modalNome = false;
        await this.$nextTick();
        this.$forceUpdate();
      },

    init() {
      this.showLoadingAskWait();
      let promises = [this.getProductsCombo(), this.getTakerData(), this.getTakerLider()];
      Promise.all(promises).then(() => {
        this.hideLoadingAskWait();
      });
    },

    calculaPremio(){
      if(this.importanciaSegurada && this.taxa && this.prazoDia){
        return ((this.importanciaSegurada * (this.taxa / 100) / 365) * this.prazoDia);
      }
    },

    limpaPremio(){
      this.valorPremio = "";
    },

    calculaPremioApi(){
      if(this.importanciaSegurada && this.taxa && this.prazoDia){
        Promise.all([this.getPremioMin()]).then((val) => {
          let premioMinimo = val[0];
          let premioCalculado = this.calculaPremio();
          this.valorPremio = Math.max(premioMinimo, premioCalculado);
        });
      }
    },

    labelButtonEtapas(step){
      switch (step) {
        case 1:
          return 'Avançar'
          break;
        case 2:
          return 'Solicitar Analise'
          break;
        case 3:
          return 'Emitir Apólice'
          break
        default:
          return 'Avançar'
          break;
      }
    },

    minDias(v){
      if(this.modalidadeResumo.qtde_minima_dias == null){
        return true;
      }else if(v >= this.modalidadeResumo.qtde_minima_dias){
        return true;
      }else{
        return `Minímo de dias permitido é ${this.modalidadeResumo.qtde_minima_dias} dias`;
      }
    },

    maxDias(v){
      if(this.modalidadeResumo.qtde_maxima_dias == null){
        return true;
      }else if(v <= this.modalidadeResumo.qtde_maxima_dias){
        return true;
      }else{
        return `Máximo de dias permitido é ${this.modalidadeResumo.qtde_maxima_dias} dias`;
      }
    },

    importanciaSeguradaRules(v){
      if(v == null){
        return "O campo é obrigatório."
      }else if(v === 'R$ 0,00'){
        return "O campo é obrigatório."
      }else{
        return true;
      }
    },

    valorRecursoRules(v){
      if(v == null){
        return "O campo é obrigatório."
      }else if(v === 'R$ 0,00'){
        return "O campo é obrigatório."
      }else{
        return true;
      }
    },

    setSpaces(text) {
      while (text.includes(" ")) {
        text = text.replace(" ", "_");
      }
      return text;
    },

    changeTagPlaceholderContent(event, tag) {
      let t = this;
      let id = this.setSpaces(tag.id);
      id = id.replace(/\(|\)/g, "").replace(/\//g,"_");

      let els = document.querySelectorAll("." + id);
      els.forEach(function (el) {
        el.innerHTML = tag.value == "" ? `[${tag.id}]` : tag.value;
      });

      this.$forceUpdate();
    },

    clearInputsValoreAndData(){
      this.valorRecurso = "R$ 0,00";
      this.importanciaSegurada = "R$ 0,00";
      this.importanciaSeguradaFormatada = null;
      this.valorPremio = "R$ 0,00";
      this.inicioVigencia = "";
      this.inicioVigenciaFormatted = "";
      this.prazoDia = "";
      this.prazoAno = "";
      this.fimVigencia = "";
      this.fimVigenciaFormatted = "";
      this.fimVigenciaYearFormatted = "";
    },

    async getProductsCombo() {
      try {
        this.itemsModalidade = await this.$store.dispatch("GET_PRODUCTS_COMBO", {});
      } catch (e) {
        console.warn(e);
      } finally {}
    },

    async getTakerLider() {
      let documento = this.me.company.document;
      let response;
      try {
        this.dadosCorretor = await this.$store.dispatch("GET_TAKER_LIDER", {documento});
      } catch (e) {
        console.warn(e);
      } finally {}
    },

    async updatePrazo() {
      await this.$nextTick();
      this.calculateFimVigencia();
    },

    calculateFimVigencia() {
      if(this.inicioVigencia && this.prazoDia){
        let newFimVigencia = this.addDays(this.inicioVigencia, this.prazoDia);
        this.fimVigencia = newFimVigencia.toISOString().split("T")[0];
        this.fimVigenciaFormatted = formatDate(this.fimVigencia);
        this.$forceUpdate();
      }

      if(this.inicioVigencia && this.prazoAno){
        this.calculaFimVigenciaRecursal();
      }
      return;
    },

    calculaFimVigenciaRecursal() {
      if (this.prazoAno > 0) {
        let fimVigencia = this.addYears(this.inicioVigencia, this.prazoAno);
        let pFimVigencia = fimVigencia.toISOString().split("T")[0];
        this.fimVigencia = pFimVigencia;
        this.fimVigenciaFormatted = formatDate(
          pFimVigencia
        );
        //prazoDia utilizado somente para apresentação no resumo e calculo de prêmio
        this.prazoDia = this.calculateDifferenceBetweenDays(this.inicioVigencia, this.fimVigencia);
        this.$forceUpdate();
      }
    },

    calculateDifferenceBetweenDays(inicio, fim) {
      if (inicio != undefined && fim != undefined) {
        let dateInicio = new Date(inicio);
        let dateFim = new Date(fim);
        let timeDiff = Math.abs(dateFim.getTime() - dateInicio.getTime());
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffDays;
      } else {
        return "";
      }
    },

    addDays(date, days) {
      var someDate = new Date(date);
      someDate.setTime(someDate.getTime() + days * 24 * 60 * 60 * 1000);
      return someDate;
    },

    addYears(date, years) {
      let year = new Date().getFullYear() + years;
      let someDate = new Date(date);
      someDate.setFullYear(year);
      return someDate;
    },

    calculaImportancia() {
      let valor = this.retiraFormatacao(this.valorRecurso);
      if (valor != "0") {
        try {
          var trintaPorcento = parseFloat(valor) * 0.3;
          valor = parseFloat(valor) + parseFloat(trintaPorcento);
        } catch (error) {
          valor = 0;
        }
      }
      this.importanciaSeguradaFormatada = valor.toLocaleString(
        "pt-BR",
        this.$settings.moneyFormatOptions
      );

      this.importanciaSegurada = valor;
    },

    retiraFormatacao(valor) {
      if (valor) {
        let valorSemFormatacao = valor.toString();
        while (valorSemFormatacao.toString().lastIndexOf(".") > -1) {
          valorSemFormatacao = valorSemFormatacao.toString().replace(".", "");
        }

        valorSemFormatacao = valorSemFormatacao
          .toString()
          .replace(".", "")
          .replace(",", ".")
          .replace(/[^0-9\.]/g, "")
          .replace("R$", "");

        return valorSemFormatacao;
      } else return "0";
    },

    checkIfDisabled(step) {

      let t = this;
      //se o passo for o atual, o formulario está válido e foi realizada a busca e retornou ok
      if(step === 1 && t.validPasso1 && t.seguradoLoad && !t.taxaIsEmpty){
        return false;
      }

      if(step === 2 && t.validPasso1 && t.validPasso2){
        return false;
      }

      return true;
    },

    //Segurado
    selectInsuredType(event) {
      this.seguradoLoad = false;
      this.insured.info = null;
      this.seguradoDocumento = '';

      if (parseInt(event.currentTarget.value) <= 2) {
        this.tipoSegurado = 1;
        if (parseInt(event.currentTarget.value) == 2) {
          this.showMsgCpf = true;
          this.tipoSegurado = 2;
        } else {
          this.showMsgCpf = false;
        }
        this.$forceUpdate();
      }
    },

    getInsure() {
      this.showMsgCpf = false;
      if (this.tipoSegurado == 1 && isValidCnpj(this.seguradoDocumento)){
        this.getInsuredByCNPJ();
      }
      if (this.tipoSegurado == 2 && isValidCpf(this.seguradoDocumento)){
        this.getInsuredByCPF();
      }
    },

    async getTakerData(){
      //variável para consulta na função setTaker e verificar se tem limites e se está OK
      let data;
      try {
        await this.$store.dispatch("GET_TAKER_DATA", {cnpj: this.me.company.document}).then(res => {this.taker.info = {...res[0]}; data=res;});
      } catch (e) {
        console.warn(e);
      } finally {
        this.setTaker(data);
      }
    },

    errorModalidade(){
      return {
        code: 0,
        message: `Modalidade ${this.modalidadeResumo.descricao} do seguro não está disponível para o tomador, por favor entre em contato com a seguradora.`,
        title: `Modalidade não disponível.`,
      };
    },

    errorSemTaxaSeguradoPrivada(){
      return {
        code: 0,
        message: `Tomador não possui taxa definida para segurado privado, por favor entre em contato com a seguradora.`,
        title: `Taxa não disponível.`,
      }
    },

    errorSemTaxaSeguradoPublica(){
      return {
        code: 0,
        message: `Tomador não possui taxa definida para segurado público, por favor entre em contato com a seguradora.`,
        title: `Taxa não disponível.`,
      }
    },

    async getProductsNew() {

      if(this.comboModalidades && this.seguradoLoad){
        let payload = {
          products: [this.modalidadeResumo.desc_abreviado],
          takerId: this.taker.info.id,
          insuredId: this.insured.info.id,
        };

        try {
          this.showLoadingAskWait();
          let data = await this.$store.dispatch("GET_PRODUCTS", payload)
          .then((response) => {
            this.product = response;
            this.prepareObjectTags();
             return;
          }).catch(this.handleError);;
        } catch (e) {
          e.response.data = this.errorModalidade();
          this.defaultHandlerError(e);
        } finally {
          //salvando taxa
          if(this.product){
            this.taker.info.grupos_credito.filter((grupo)=>{
              let tipos_pessoas_taxa_publica = ["ORGAO_PUBLICO", "FISICA"];
              let usar_taxa_publica = tipos_pessoas_taxa_publica.includes(this.insured.info.tipo_pessoa);
              let usar_taxa_privada = !usar_taxa_publica;
              if(grupo.id_grupo == this.product.id_grupo){
                if(usar_taxa_publica && grupo.taxa_segurado_publico){
                  this.taxa = grupo.taxa_segurado_publico;
                } else if (usar_taxa_privada && grupo.taxa_segurado_privado) {
                  this.taxa = grupo.taxa_segurado_privado 
                } else if (grupo.id_grupo == "LICJUDRECUR" && usar_taxa_privada && !grupo.taxa_segurado_privado) {
                  // fix para Judicial Recursal e Trabalhista porque essas modalidades não têm taxa privada.
                  this.taxa = grupo.taxa_segurado_publico;
                } else {
                  this.taxa = null;
                }
                this.taxaIsEmpty = false;
              }
              });
              //não existe taxa
              if(!this.taxa){
                this.taxaIsEmpty = true;
                this.product = null;
                this.clearInputsValoreAndData();
                let e = {
                  response:{
                    data: {},
                    options:{},
                  },
                };
                if (usar_taxa_publica && !grupo.taxa_segurado_publico){
                  e.response.data = this.errorSemTaxaSeguradoPublica()
                }
                if (usar_taxa_privada && !grupo.taxa_segurado_privado) {
                  e.response.data = this.errorSemTaxaSeguradoPrivada()
                }
                this.defaultHandlerError(e);
              }
          }
          //Move para o fina da página após a consulta dos produtos
          let element = document.getElementById("bottom");
          element.scrollIntoView();
          this.hideLoadingAskWait();
        }
      }
    },

    async getInsuredByCPF() {

      let t = this;
      if (!this.seguradoDocumento) return;

      if (!isValidCpf(this.seguradoDocumento.replace(/[^\w\s]/gi, ""))) {
        let options = {
          code: 7001,
          details: null,
          message:
            "O CPF informado não é valido, por favor, corrija e tente novamente.",
          title: "CPF inválido",
        };

        this.setErrorModal(options);
        return;
      }

      let data;
      let document = this.seguradoDocumento.replace(/[^\w\s]/gi, "");

      try {
        this.showLoadingAskWait();
        data = await this.$store.dispatch("GET_INSURED_DATA", { document });
      } catch (e) {
        if (e && e[0] && !e[0].ativo) {
          return this.handleInactivePersonError(e[0], "Segurado");
        }
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }

      //Check para ver se é o mesmo do que está logado
      if (data.length > 0 && (data[0].id == this.me.company.i4pro_id)) {
        this.handleSameCNPJTakerInsured();
        return;
      }

      // Se não encontrar o CPF deverá ser informado no nome para cadastro
      if (data.length == 0) {
        this.hideLoadingAskWait();
        // Demonstra a modal para informar o nome
        this.insuredAddress ={};
        this.insuredName = null;
        this.$refs.novoSegurado.reset();
        this.$refs.formEnderecoComponent.$refs.formEndereco.reset();
        this.modalNome = true;
      } else {
        this.insured.info = data[0];
        this.tipo_pessoa = this.insured.info.tipo_pessoa;
        this.insured.info.nome = this.insured.info.nome.toUpperCase();
        this.seguradoLoad = true;
        Promise.all([this.getProductsNew(), this.getTakerData()]).then(() => {
        this.hideLoadingAskWait();
        });

        this.alertText = this.handleAlertText2(
          "Cadastro recuperado com sucesso!"
        );

        await this.$nextTick();

        this.$forceUpdate();
      }
    },

    async getInsuredByCNPJ() {
      if (!this.seguradoDocumento) return;

      if (!isValidCnpj(this.seguradoDocumento.replace(/[^\w\s]/gi, ""))) {
        let options = {
          code: 7001,
          details: null,
          message:
            "O CNPJ informado não é valido, por favor, corrija e tente novamente.",
          title: "CNPJ inválido",
        };

        this.setErrorModal(options);
        return;
      }

      let data;
      let document = this.seguradoDocumento.replace(/[^\w\s]/gi, "");

      try {
        this.showLoadingAskWait();
        data = await this.$store.dispatch("GET_INSURED_DATA", { document });
      } catch (e) {
        if (e && e[0] && !e[0].ativo) {
          return this.handleInactivePersonError(e[0], "Segurado");
        }
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }

      if (!data) return;
      //Check para ver se é o mesmo do que está logado
      if (data[0].id == this.me.company.i4pro_id) {
        this.handleSameCNPJTakerInsured();
        return;
      }
      this.alertText = this.handleAlertText2(
        "Cadastro recuperado com sucesso!"
      );
      this.insured.info = data[0];
      this.insured.info.nome = this.insured.info.nome.toUpperCase();
      this.tipo_pessoa = this.insured.info.tipo_pessoa;
      this.seguradoLoad = true;
      Promise.all([this.getProductsNew(), this.getTakerData()]).then(() => {
        this.hideLoadingAskWait();
      });

      await this.$nextTick();

      this.$forceUpdate();
    },

    async salvarSegurado() {
      if(this.$refs.novoSegurado.validate() &&
        this.$refs.formEnderecoComponent.$refs.formEndereco.validate()){
        let data;

        try {
          this.showLoadingAskWait();

          data = await this.$store.dispatch("INSERT_INSURED", {
            document:this.seguradoDocumento.replace(/[^\w\s]/gi, ""),
            data:{
              tipo_pessoa: "FISICA",
              nome:this.insuredName,
              endereco:{...this.insuredAddress, numero: this.insuredAddress.numero || 'SN'}
            }
          });
        } catch (e) {
          if (e && e[0] && !e[0].ativo) {
            return this.handleInactivePersonError(e[0], "Segurado");
          }
          this.defaultHandlerError(e);
        } finally {
          this.modalNome = false;
          this.hideLoadingAskWait();
        }

        this.alertText = this.handleAlertText2(
          "Cadastro salvo com sucesso!"
        );

          this.insured.info = {...data, nome: data.nome.toUpperCase()};
          this.tipo_pessoa = this.insured.info.tipo_pessoa;

          this.seguradoLoad = true;
          Promise.all([this.getProductsNew(), this.getTakerData()]).then(() => {
          this.hideLoadingAskWait();
          });

          this.alertText = this.handleAlertText2(
            "Cadastro recuperado com sucesso!"
          );

        this.stepCompleted = 2;
        this.modalNome = false;
        await this.$nextTick();
        this.$forceUpdate();
      }
    },

    prepareObjectTags() {
      let match = null;
      let regex = /\%TAG_(.*?)\%/gi;
      let counter = 0;
      this.TAGs = [];
      this.fullTAGs = [];

      if (!this.product) {
        this.selectedProduct = false;
        return false;
      }
      let tagNames = [];
      let fullTags = [];

      while ((match = regex.exec(this.product.objeto)) != null) {
        let tagName = match[1].trim();
        let fullTag = match[0];

        if (!tagNames.includes(tagName)) {
          tagNames.push(tagName);
          fullTags.push(fullTag);
        }
      }

      for (let i = 0; i < tagNames.length; i++) {
        counter++;
        this.TAGs.push({
          label: tagNames[i],
          id: tagNames[i].replace(".", ""),
          fulltag: fullTags[i].replace(".", ""),
          value: "",
        });
      }

      counter = 0;
      this.product.objeto = this.product.objeto.replace(regex, (match, p1) => {
        counter++;
        p1 = p1.replace(/\./g,' ').trim().replace(/\(|\)/g, "").replace(/\//g,"_");
        return (
          " <span class='font-weight-bold proposta__tag-text " +
          this.setSpaces(p1) +
          "'>[" +
          p1 +
          "]</span> "
        );
      });
    },

    focus() {
      this.showMsgCpf = false;
    },

    inputActive() {
      if (this.insured) {
        if (this.insured.cnpj != null) {
          if (this.insured.cnpj.length > 0) {
            this.showMsgCpf = false;
          }
        }
      }
    },
    //Fim segurado

    handleRouteChanging(item) {
      if (["Pendências"].includes(item.routeName)) {
        this.emBreveModal = true;
        return;
      }
      if (item.routeName) this.$router.push({ name: item.routeName });
      else this[item.action]();
    },

    resetErroResponse() {
      this.erroResponse = {
        status: 0,
        data: {},
        mostraBtnAcao: false,
      };
    },

    emitirApolice(options = {}) {
      this.dialogEmitindoProposta = true;
      this.dialogEmitirProposta = false;

      if (options.alterarVigencia) {
        this.apolice.aceite_alterar_vigencia = true;
        this.resetErroResponse();
      }

      if (this.apolice != null) {
        const axio = axios.create({
          baseURL: config.apiUrl + config.versoes[0],
        });

        this.id_proposta = this.proposta.id;
        this.id_produto = this.proposta.id_produto;

        axio
          .post("/emissao", this.apolice)
          .then((response) => {
            const rd = response.data;
            this.postResponse = rd;

            if (response.status == 200 && response.data.id_apolice) {
              this.propostaEmitida = true;
            } else this.propostaEmitida = false;
            this.erroResponse.mostraBtnAcao = true;
          })
          .catch((e) => {
            let mostraBtnAcao = e.response.data.code != 4051;
            this.propostaEmitida = false;
            this.erroResponse = {
              status: e.response.status,
              data: e.response.data,
              mostraBtnAcao,
            };
          });
      }
    },

    ...mapActions(["POST_QUESTIONAMENTO"]),

    moneyToFloat(value) {
      try {
        return parseFloat(value.replace(/[^0-9,-]+/g, "").replace(",", "."));
      } catch (e) {
        return 0;
      }
    },

    definePolice(postData) {
      this.apolice = postData;
    },

    loadTermos() {
      this.termos = `
    As informações e documentos fornecidos para o exame desta Proposta de Seguros, através deste portal, representam os elementos necessários para a análise do risco por parte da Seguradora, bem como, são verdadeiros e estão em conformidade com o Contrato Principal, ou similar, a ser garantido.
    O Tomador, por meio próprio ou por seu Corretor de Seguros, declara ainda, expressamente, ter lido, compreendido e que está de acordo com as condições aqui estabelecidas, incluindo as Condições Contratuais deste seguro.
    `;
    },

    async sendQuestionamento(data) {
      if (data == "") {
        this.hideLoadingAskWait();

        let options = {
          code: null,
          details: null,
          message: "Favor informar uma observação.",
          title: "Aviso",
        };
        this.setErrorModal(options);

        return;
      }

      try {
        this.showLoadingAskWait();
        await this.POST_QUESTIONAMENTO({
          observacoes: data || "",
          propostaId: +this.$route.params.propostaId,
          produtoId: +this.$route.params.produtoId,
        });
        this.dialogQuestionamento = false;
        this.questionamentoSucessoModal = true;
      } catch (e) {
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }
    }, // . sendQuestionamento

    successReturnClick() {
      this.successModal = false;
      this.$router.push({ path: "/mesa-de-trabalho" });
    },

    validateLimitModalClick() {
      this.validateLimitModal = false;
    },

    //colocar uma data minima no date picker, não pode ser a anterior
    getFimVigenciaMinimumDate() {
      return new Date().toISOString().slice(0, 10);
    },

    async quitProposal() {
      let propostaId = this.idConsultaProposta.id_proposta;
      let produtoId = this.idConsultaProposta.id_produto;

      if (produtoId && propostaId) {
        let payload = {
          id_proposta: propostaId,
          id_produto: produtoId,
        };

        if (this.step == 3) {
          if (this.id_motivo > 0) payload.id_motivo = this.id_motivo;
          if (this.observacao != "") payload.observacao = this.observacao;
        }

        this.showLoadingAskWait();
        try {
          payload.status = "CANCELADA";
          await this.$store.dispatch("QUIT_PROPOSAL", payload);
        } catch (e) {
          this.defaultHandlerError(e);
          return;
        } finally {
          this.hideLoadingAskWait();
        }
      }
      this.$router.push({ path: "/home" }).catch(() => {});
      this.$router.go();
    },

    updateInsured(insured) {
      this.insured = Object.assign(this.insured, insured);
    },

    updateInsuredFormValid(formValid) {
      this.insuredFormValid = formValid;
    },

    // Quando clica em uma opção não disponível
    showMsgOpUnavailable() {
      // Opções indisponíveis!
      let options = {
        code: null,
        details: null,
        message:
          "Para essa operação entre em contato com nossa equipe comercial.",
        title: "Operação indisponível.",
      };
      this.setErrorModal(options);
    },

    changeStep({ index: step }) {
      //limpa os valores das tags no passo 2 ao trocar de passo
      if(step < 2){
        for(let tag of this.TAGs){
          tag.value = '';
        }
      }

      if(step == 3) return;

      if (this.step > step && this.step < 3) {
        this.step = ++step;
        this.resetScroll();
      }
    },

    resetScroll() {
      document.querySelectorAll(".white_background")[0].scrollTo(0, 0);
      this.$forceUpdate();
    },

    groupBy(array, key) {
      if (!array.length) {
        return;
      }
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },

    modalTomadorInativo() {
      let options = {
        code: null,
        details: null,
        message:
          "Desculpe, este tomador não é compatível com a política da JNS Seguradora.",
        title: "Problema ao recuperar os dados tomador.",
      };
      this.setErrorModal(options);
    },

    compareWithToday(date) {
      if (date == null || date == "") return false;

      try {
        let today = new Date();
        let compareYear = date.substring(0, 4);
        let compareMonth = date.substring(5, 7);
        let compareDay = date.substring(8, 10);
        let compareDate = new Date(
          compareYear,
          parseInt(compareMonth) - 1,
          compareDay
        );

        return compareDate > today;
      } catch (error) {
        return false;
      }
    },

    /* Busca do Tomador por CNPJ e busca dos limites */
    async setTaker(data) {
      this.tomadorAnaliseCredito = undefined;
      this.erroBuscaLimite = false;
      this.stepCompleted = 1;

      // Se a data for maior que a data de hoje, continua a execução, caso contrário valida a situação
      if (this.compareWithToday(data[0].data_validade_limite)) {
        if (!data[0].situacao_ativo || !data[0].ativo) {
          this.modalTomadorInativo();
          this.checkIfDisabled(this.step, this.stepCompleted);
          return;
        }
      }

      this.alertText = this.handleAlertText2(
        this.getTakerAlertMessage(data[0])
      );

      // prevenir se necessario, toda vez que alguma pesquisa acontecer
      if (data[0].status_nomeado == "OUTRO_NOMEADO") this.stepCompleted = 0;

      await this.$nextTick();
      this.taker.info = data[0];

      if (data.tomador_credito)
        this.taker.tomador_credito = data.tomador_credito;
      else this.taker.tomador_credito = null;

      // Validar se pesquisa do tomador retornou limites
      if (
        !this.taker.info.sublimites.length &&
        this.taker.info.status_nomeado != "OUTRO_NOMEADO"
      ) {
        // buscar sublimites para exibir na tabela
        this.getLimite();
      } else if (
        !this.compareWithToday(data[0].data_validade_limite) &&
        this.taker.info.status_nomeado != "OUTRO_NOMEADO"
      ) {
        this.msgErroBuscaLimite =
          "Prezado Corretor, solicitamos que prossiga no preenchimento da proposta, para verificar as condições de limites e taxas.";
        this.erroBuscaLimite = true;
      } else if (this.taker.info.status_nomeado == "OUTRO_NOMEADO") {
        this.msgErroBuscaLimite =
          "Não foi possível obter os limites pois o tomador possui outro corretor nomeado";
        this.erroBuscaLimite = true;
      } else if (
        ["MIDDLE_PLUS", "CORPORATE", "CORPORATE_PLUS"].includes(
          this.taker.info.faturamento
        ) &&
        this.taker.info.cadastro_revisado != "REVISADO" &&
        (!this.taker.info.grupos_credito ||
          !this.taker.info.grupos_credito.length)
      ) {
        this.msgErroBuscaLimite =
          "Prezado Corretor, o tomador passará por análise de crédito manual. Prossiga com a inserção da proposta.";
        this.erroBuscaLimite = true;
      } else {
        this.limitesAgrupadosPorModalidade = this.groupBy(
          this.taker.info.sublimites,
          "modalidade"
        );

        await this.$nextTick();
        this.$forceUpdate();
      }
    },

    async getLimite() {
      this.buscandoLimite = true;
      this.erroBuscaLimite = false;
      let limitsInfo;

      try {
        limitsInfo = await this.$store.dispatch("GET_TAKER_LIMITES", {
          id: this.taker.info.id,
        });

        this.taker.info = limitsInfo;
        this.idTomadorPesquisaLimites = limitsInfo.id;
        this.buscandoLimite = false;

        if (this.taker.info.situacao_ativo && this.taker.info.ativo) {
          if (
            ["MIDDLE_PLUS", "CORPORATE", "CORPORATE_PLUS"].includes(
              this.taker.info.faturamento
            ) &&
            this.taker.info.cadastro_revisado != "REVISADO" &&
            (!this.taker.info.grupos_credito ||
              !this.taker.info.grupos_credito.length)
          ) {
            this.msgErroBuscaLimite =
              "Prezado Corretor, o tomador passará por análise de crédito manual. Prossiga com a inserção da proposta.";
            this.erroBuscaLimite = true;
          }
        } else {
          this.handlerErrors({
            data: {
              message: this.getTakerAlertMessage(this.taker.info),
              title: "Problema ao recuperar os dados tomador.",
            },
            response: { status: 409 },
          });
        }
      } catch (e) {
        if (e.data) {
          if (e.data.code == "4054") {
            this.msgErroBuscaLimite = this.handlerErrors(e);
          } else {
            if (e.code) {
              if (e.code == "4054") {
                this.msgErroBuscaLimite = this.handlerErrors(e);
              }
            } else this.msgErroBuscaLimite = this.handlerErrors(e);
          }
        } else this.msgErroBuscaLimite = this.handlerErrors(e);

        this.idTomadorPesquisaLimites = 0;
        this.erroBuscaLimite = true;
        this.buscandoLimite = false;

      } finally {
        this.bloqueiaErroBuscaLimite = this.erroBuscaLimite;

        if (
          this.taker.info.id == this.idTomadorPesquisaLimites &&
          !this.erroBuscaLimite
        ) {
          this.taker.info = limitsInfo;
          this.idTomadorPesquisaLimites = 0;
          this.buscandoLimite = false;
          this.limitesAgrupadosPorModalidade = this.groupBy(
            this.taker.info.sublimites,
            "modalidade"
          );
        }
      }
      await this.$nextTick();
      this.$forceUpdate();
    },

    async getPremioMin() {
      let payload = {
        importancia_segurada: parseFloat(this.importanciaSegurada),
        vigencia: parseInt(this.prazoDia),
        documento: this.me.company.document,
        id_prod: this.modalidadeResumo.id_produto,
      };
      let data;
      try {
        data = await this.$store.dispatch("GET_PREMIO_MIN", payload);
      } catch (e) {
        this.defaultHandlerError(e);
        return;
      } finally {
        return data;
      }

      this.hideLoadingIndicator();
      this.$forceUpdate();
    },

    getTakerAlertMessage(taker) {
      if (taker.status_nomeado == "OUTRO_NOMEADO") {
        return "Tomador já possui corretor nomeado, favor inserir a Carta de Nomeação.";
      }
      return "Cadastro salvo com sucesso!";
    },

    unselectTaker() {
      let t = this;
      this.$set(this.taker, "info", false);
      this.showSelectTaker = true;
      this.stepCompleted = 0;
      this.taker.showFormEconomicGroup = false;

      this.taker.hasParticipants = false;
      this.takerParticipants = [];
      this.$forceUpdate();
    },

    preparePerson(person) {
      person.nome = person.name;
      person.endereco = person.enderecos[0];
      person.endereco.logradouro = [
        person.endereco.rua,
        person.endereco.numero,
        person.endereco.complemento,
      ].join(", ");

      delete person.notFound;
      delete person.enderecos;
      delete person.stepType;
      delete person.name;
      delete person.endereco.rua;
      delete person.endereco.numero;
      delete person.endereco.complemento;
      return person;
    },

    handleSameCNPJTakerInsured() {
      let e = {
        response: {
          data: {
            title: "Por favor, escolha outro CNPJ",
            message: "Tomador e segurado não podem ser iguais.",
          },
          status: 409,
        },
      };
      this.defaultHandlerError(e);
    },

    set404ErrorMessage(e, type) {
      let person =
        type == "taker" ? "tomador" : type == "insured" ? "segurado" : false;

      let errorMessage = {
        title: `${capitalize(person)} não encontrado`,
        message: `Não foi encontrado nenhum ${person}`,
      };

      if (e.response.status == 404 || e.response.status == 200) {
        e.response.data = errorMessage;
        e.response.status = 404;
      }
      return;
    },

    handleInactivePersonError(e, personType) {
      let t = this;
      let options = {
        title: `${personType} Inativo`,
        message: `Desculpe, este ${personType} não é compatível com a política da JNS Seguradora.`,
      };
      this.setErrorModal(options);
      return;
    },

    async desistir() {
      console.warn("desistindo da proposta");

      // Buscar motivos
      try {
        this.motivos = await this.$store.dispatch("GET_REASONS");
      } catch (e) {
        this.defaultHandlerError(e);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      if (this.step != 3) {
        this.confirmQuitModal = true;
        this.modalDesistir = true;
      } else {
        this.confirmQuitModal = false;
        this.modalDesistir = true;
      }
    },

    showQuestionamento() {
      this.dialogQuestionamento = true;
    },

    semProdutosClick() {
      this.semProdutos = false;
    },

    async buscarParametros() {
      let parameters = await this.$store.dispatch("GET_PARAMETERS");
      return parameters;
    },

    async buscarParametrosTomador() {
      let parameters = await this.$store.dispatch("GET_PARAMETERS_TOMADOR");
      return parameters;
    },

    /* Direcionamento de cada etapa (avançar) */
    async goToNextStep(step) {
      if(this.step < 3){
        this.step++;
      }
      if(this.step == 3) return;
    },

    closeResumoProposta() {
      this.$nextTick(() => {
        this.resetScroll();
      });
      this.dialogResumoProposta = false;
      this.$forceUpdate();
    },

    /* TODO: Novos processos para envio no Passo 4 - Apólice

      Ao enviar os documentos é realizado o inicio do processamento
      1 - Envio da proposta
      2 - Envio dos arquivos
      3 - Aprovação automática de crédito
      4 - Aprovação automática de subscrição
      5 - Aprovação automática de resseguro
    */

    fecharAnaliseCreditoModal(data) {
      this.taker.tomador_credito = data;
      this.dialogAnaliseCredito = false;
      this.$forceUpdate();
    },

    solicitarLimitesAnaliseCredito(data) {
      this.resetScroll();
      this.tomadorAnaliseCredito = data;
      this.dialogAnaliseCredito = false;
      this.getLimite();
      this.$forceUpdate();
    },

    // Validar a importância segurada com o limite para o produto selecionado se cadastro != NAO_REVISADO
    validateLimitByProduct(inportanceValue) {
      let limitByProductValid = true;

      /* FIXME: Novo processo de validação do limite por produto necessário devido a atualização no backend.*/

      return limitByProductValid; // Não validando neste momento.

      // Se cadastro é não revisado é necessário validar a importância maior que o limite
      if (this.taker.info.cadastro_revisado != "NAO_REVISADO") {
        let sublimite = this.taker.info.sublimites.find(
          (subs) => subs.grupo_id === this.product.id_grupo
        );

        let validatedLimit = false;
        if (sublimite != null) {
          if (sublimite.limite_credito != null) {
            validatedLimit = true;
          }
        }

        if (validatedLimit) {
          if (inportanceValue > sublimite.limite_credito) {
            console.warn(
              `Importancia ${inportanceValue} maior que o limite ${sublimite.limite_credito}`
            );
            this.validateLimitModal = true;
            limitByProductValid = false;
          } else {
            this.validateLimitModal = false;
            if (this.development) {
              console.warn("Salvando proposta normalmente");
            }
          }
        } else {
          this.validateLimitModal = false;
          salvarProposta = false;
          console.error(
            "Não foi possível validar o limite de crédito, o sublimite estava null ou não tem limite_credito"
          );

          this.alertText = this.handleAlertText2(
            "Não encontramos configurações para validar a proposta! Tente novamente!",
            "warning"
          );

          limitByProductValid = false;
        }
      } // ./Cadastro Revisado
      else {
        this.validateLimitModal = false;
        if (this.development) {
          console.warn("Salvando proposta para cadastro não revisado");
        }
      }

      return limitByProductValid;
    }, // ./validateLimitByProduct

    /* início step 2 */
    async processTheRequest() {
      let salvarProposta = false;

      let inportanceValue = this.moneyToFloat(
        this.product.coberturas[0].importancia_segurada
      );

      if (this.development) {
        console.log(
          `Importancia ${inportanceValue} validada com parâmetro e arquivos a enviar.`
        );
      }

      if (this.validateLimitByProduct(inportanceValue)) {
        this.dialogProcessandoSolicitacao = true;

        if (this.development) {
          console.log(`Iniciando salvamento da proposta.`);
        }

        this.saveProposal({ status: "EM_ANALISE", step: 4 });
      }
    },

    // Salvar a proposta e executar os processos
    async saveProposal(options) {
      let t = this;
      let response;

      let prepareTags = (tag) => {
        let res = {
          valor: tag.value,
          tag: tag.label.trim(),
          full_tag: tag.fulltag.trim()
        };
        return res;
      };
      let payload =
        {
          coberturas: [
            {
              id: this.product.coberturas[0].id_cobertura,
              importancia_segurada: this.importanciaSeguradaFormatada ?
                                this.retiraFormatacao(this.importanciaSeguradaFormatada)
                                  :
                                this.retiraFormatacao(this.importanciaSegurada),
              inicio_vigencia: this.inicioVigenciaFormatted.split("/").reverse().join("-"),
              fim_vigencia: this.fimVigenciaFormatted.split("/").reverse().join("-"),
            }
          ],
          id_produto: this.modalidadeResumo.id_produto,
          id_proposta: false,
          id_segurado: this.insured.info.id,
          id_tomador: this.taker.info.id,
          status: "EM_ANALISE",
          tags: this.TAGs.map(prepareTags),
        }
      this.restartProccess();

      if (options && options.status) {
        payload.status = options.status;
      }

      let processExecuted = false;

      try {
        this.startProcess(1);
        response = await t.$store.dispatch("POST_PROPOSTA", payload);
        if (response) this.endProcess(1, "success", response.id);
        else {
          this.endProcessAndFinalize(1, "error");
          return;
        }
      } catch (e) {
        this.endProcessAndFinalize(1, "error", e);
        return;
      }

      if (response.status === "EM_CADASTRO" && options && options.step === 4) {
        this.startProcess(2);

        try {
          payload.status = "ANALISE_CREDITO";
          payload.id_proposta = response.id;
          payload.id_produto = response.id_produto;
          response = await t.$store.dispatch("PATCH_PROPOSTA", payload);
          if (response) {
            this.id_proposta = response.id;
            this.id_produto = response.id_produto;
            this.propostaId = response.id;
            this.produtoId = response.id_produto;
          } else {
            this.endProcessAndFinalize(2, "error");
            return;
          }
        } catch (e) {
          this.endProcessAndFinalize(2, "error", e);
          return;
        }

        this.statusProposta = response.status;

        /* ------------- Análise de Crédito ---------- */
        if (
          response.status == "PROPOSTA_RECUSADA" ||
          response.status == "RECUSADA"
        ) {
          let args = {
            message: "Proposta recusada na análise automática de crédito.",
          };
          this.endProcessAndFinalize(2, "error", args);
          return;
        } else if (
          response.status == "CORRETOR_ANALISE_CREDITO" ||
          response.status == "SEGURADORA_ANALISE_CREDITO"
        ) {
          if (response.status == "CORRETOR_ANALISE_CREDITO")
            this.tabDetalharProposta = "#credito";
          this.endProcessAndFinalize(2, "error");
          return;
        } else if (response.status == "SEGURADORA_ANALISE_SUBSCRICAO") {
          /* ---------- Análise de Subscrição -----*/

          this.endProcess(2, "success");

          this.startProcess(3);

          try {
            payload.status = "ANALISE_SUBSCRICAO";
            payload.id_proposta = response.id;
            payload.id_produto = response.id_produto;
            response = await t.$store.dispatch("PATCH_PROPOSTA", payload);
            if (response) {
              if (response.status == "SEGURADORA_ANALISE_SUBSCRICAO") {
                this.endProcessAndFinalize(3, "error", {
                  message:
                    "A proposta foi direcionada para análise de subscrição.",
                });
                return;
              } else if (response.status == "CORRETOR_ANALISE_EMISSAO") {
                this.endProcess(3, "success");
                this.startProcess(4);

                this.actualProcessStepErrorMessage =
                  "Proposta aprovada automaticamente.";
                this.idConsultaProposta.id_proposta = response.id;
                this.idConsultaProposta.id_produto = response.id_produto;
                this.prepareStep5Edit();
                this.processSuccess = true;
                this.endProcess(4, "success");
                this.finalizeProcess();
                return;
              } else {
                this.endProcessAndFinalize(3, "error");
                this.tabDetalharProposta = "#subscricao";
                return;
              }
            } else {
              this.endProcessAndFinalize(3, "error");
              return;
            }
          } catch (e) {
            this.endProcessAndFinalize(3, "error", e);
            return;
          }
        } else if (response.status == "CORRETOR_ANALISE_SUBSCRICAO") {
          this.tabDetalharProposta = "#subscricao";
          this.endProcessAndFinalize(3, "error");
          return;
        } else if (response.status == "CORRETOR_ANALISE_RESSEGURO") {
          this.tabDetalharProposta = "#resseguro";
          this.endProcessAndFinalize(4, "error");
          return;
        }
      }

      // Finalizar todo os processos
      this.finalizeProcess();
    }, // ./saveProposal

    startProcess(step) {
      this.dialogProcessandoSolicitacao = true;
      this.processInExecution = true;
      this.processSteps.find((item) => item.step == step).display = true;
    }, // ./startProcess

    endProcess(step, status, args) {
      this.processSteps.find((item) => item.step == step).status = status;
      if (status == "success")
        this.processSteps.find(
          (item) => item.step == step
        ).text = this.processSteps
          .find((item) => item.step == step)
          .success_text.replace("arg", args);
      else if (status == "error") {
        this.actualProcessStepErrorMessage = "";
        if (args != null) {
          if (args.response) {
            if (args.response.data) {
              this.actualProcessStepErrorMessage = args.response.data.message;
            }
          } else if (args.message != null) {
            this.actualProcessStepErrorMessage = args.message;
            if (args.details != null) {
              this.actualProcessStepErrorMessage += "</br>" + args.details;
            }
          } else {
            this.actualProcessStepErrorMessage = this.processSteps.find(
              (item) => item.step == step
            ).error_text;
          }
        } else {
          if (
            this.processSteps.find((item) => item.step == step).details != null
          ) {
            if (this.statusProposta.includes("RECUSADA"))
              this.actualProcessStepErrorMessage = this.processSteps.find(
                (item) => item.step == step
              ).details.recusado;
            else if (this.statusProposta.includes("CORRETOR"))
              this.actualProcessStepErrorMessage = this.processSteps.find(
                (item) => item.step == step
              ).details.corretor;
            else
              this.actualProcessStepErrorMessage = this.processSteps.find(
                (item) => item.step == step
              ).details.seguradora;
          } else {
            this.actualProcessStepErrorMessage = this.processSteps.find(
              (item) => item.step == step
            ).error_text;
          }
        }

        this.processSteps.find(
          (item) => item.step == step
        ).text = this.processSteps.find((item) => item.step == step).error_text;
      }
    }, // ./endProcess

    // Finalizar um processo e juntamente finalizar todo o processo
    endProcessAndFinalize(step, status, args) {
      this.endProcess(step, status, args);
      this.finalizeProcess();
      return;
    }, // ./endProcessAndFinalize

    finalizeProcess(clean) {
      this.processInExecution = false;
      this.isProcessing = false;
    }, // ./finalizeProcess

    restartProccess() {
      this.processSuccess = false;
      this.processInExecution = false;
      this.actualProcessStepErrorMessage = "";
      this.processSteps.forEach((item) => {
        item.display = false;
        item.status = "pending";
      });
    }, // ./restartProccess
    /* fim step 2 */

    /* início step 3 */
    async prepareStep5Edit() {
      let response;
      let payload = {
        id_produto: this.idConsultaProposta.id_produto,
        id_proposta: this.idConsultaProposta.id_proposta,
      };
      this.showLoadingAskWait();
      try {
        response = await this.$store.dispatch("GET_PROPOSAL", payload);
      } catch (e) {
        this.defaultHandlerError(e);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      if (response.status != "CORRETOR_ANALISE_EMISSAO") {
        this.$router.push({ path: "/mesa-de-trabalho" });
      }
      this.mostraBtnQuestionamento = true;
      this.isStep5Edit = false;
      this.proposta = response;
    },

    async getMinuta() {
      let payload = {
        id_produto: this.idConsultaProposta.id_produto,
        id_proposta: this.idConsultaProposta.id_proposta,
      };
      let data;
      this.showLoadingAskWait();
      try {
        data = await this.$store.dispatch("GET_MINUTA", payload);
      } catch (e) {
          e.response.data = {
          code: 5013,
          message: "Não foi possível gerar a minuta da proposta.",
          title: "Minuta não disponível",
        };
        this.defaultHandlerError(e);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      this.hideLoadingIndicator();
      this.$forceUpdate();
    },

    abrirModalTermosAceite() {
      this.dialogEmitirProposta = true;
      this.aceitaTermos = false;
    },

    toggleShowDetails() {
      this.showDetails = !this.showDetails;
    },

    /* fim step 3 */

    goto(sector) {
      if (sector == "timeline") {
        this.$router.push({
          path: `/proposta/${this.id_proposta}/${
            this.id_produto + this.tabDetalharProposta
          }`,
        });
        this.$router.go();
      } else if (sector == "home") {
        this.dialogProcessandoSolicitacao = false;
        this.$router.push({ path: "/home" }).catch(() => {});
        this.$router.go();
      } else {
        this.step = 3;
        this.dialogProcessandoSolicitacao = false;
      }
    }, // ./ goto

    boqueiaUnloadPage(evt) {
      if (this.isProcessing) {
        evt.returnValue = true;
        return true;
      }
    },
  },

  mounted() {
    let t = this;
    //retirando carregamento da tela?
    this.hideLoadingIndicator();
    this.moneyConfig = this.$settings.moneyConfig;

    this.$store.commit("SET_PAGENAME", t.$route.name);
    this.timeline = this.$settings.mocks.timeline;
    this.loadTermos();
    this.$forceUpdate();
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.boqueiaUnloadPage);
  },

  watch: {
    inicioVigencia(){
      this.inicioVigenciaFormatted = formatDate(this.inicioVigencia);
    },

    fimVigencia(){
      this.fimVigenciaFormatted = formatDate(this.fimVigencia);
      this.updatePrazo();
    },

    seguradoDocumento(){
      this.seguradoLoad = false;
      this.insured = {};
      this.clearInputsValoreAndData();
    },

    valorRecurso(){
      this.calculaImportancia();
    },

    comboModalidades(){
      this.clearInputsValoreAndData();
      this.itemsModalidade.filter((prod) => {
        if(prod.id_produto == this.comboModalidades){
          this.modalidadeResumo = prod;
        }
      });
      Promise.all([this.getProductsNew()]).then(() => {
        this.hideLoadingAskWait();
      });
    },

    prazoDia(){
      this.updatePrazo();
    },

    prazoAno(){
      this.updatePrazo();
    },

    dialogProcessandoSolicitacao: function (value) {
      if (value && this.step == 4) this.isProcessing = true;
      else this.isProcessing = false;

      return value;
    },

    step() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
#jns {
  $whiteColor: #fff;
  $grayLightColor: rgb(146, 145, 145);
  .jns-button {
    font-size: 16px;
    text-transform: none;
    margin: 6px 12px;
  }

  .container.grid-list-xl .layout .flex {
    padding: 12px;
  }

  .modal {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 16px;

    .headline {
      margin-bottom: 2rem;
    }

    .jns-input {
      margin-top: 1.2rem;
    }

    .buttons-desistir {
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin: 0;
      padding: 0;

      .jns-button {
        margin: 0;
        padding: 0;
        width: 48%;
      }
    }

    @media screen and (max-width: 276px) {
      .buttons-desistir {
        flex-wrap: wrap;
        .jns-button {
          width: 100%;
          margin-bottom: 1rem;
        }
      }
    }
  }
  .container {
    max-width: 100%;
    padding: 0 !important;
  }

  .full-height {
    .grid-flex-column {
      height: calc(100% - 64px);
      margin: 64px 0;
      padding: 0 !important;

      .proposta {
        display: flex;
        width: 100%;
        height: 100%;

        .add-proposta {
          display: flex;
          flex-direction: column;
          width: 70%;
          padding: 4.5vh 4.5vh 0 4.5vh;

          .container-proposta {
            height: 100%;
            .insured {
              color: #061d45;
              font-weight: bold;
            }

            .form-proposta {
              display: flex;
              flex-direction: column;

              .msg-informa {
                color: #282498;
                text-shadow: rgba(0, 0, 0, 0.26);
                font-size: 1.2rem;
              }
              .jns-input {
                margin: 2% 0;
              }

              .box-recursal {
                display: flex;
                flex-direction: row;
                width: 100%;
                align-items: center;

                .valor-recurso {
                  width: 24%;
                  margin-right: 2%;
                }

                .importancia-segurada,
                .inicio-vigencia,
                .prazo-dia {
                  width: 24%;
                  margin-right: 2%;
                }

                .final-vigencia,
                .prazo-ano {
                  width: 24%;
                }

                .importancia-segurada {
                  display: flex;
                  align-items: center;

                  .box-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 45px;
                    margin-bottom: 8px;
                    border-radius: 0 4px 4px 0;

                    .icon_recursal {
                      cursor: help;
                      margin-bottom: 3px;
                    }
                  }

                  .msg_recursal {
                    width: 53%;
                    background-color: white;
                    color: black;
                    position: relative;
                    border-radius: 4px;
                    z-index: 99999;
                    box-shadow: 0 0 1em #ccc;
                    padding: 12px;
                    position: absolute;
                    left: 23%;
                    bottom: 0px;
                    font-size: 0.813rem;

                    p {
                      text-align: left;
                      margin-bottom: 0;
                      font-weight: normal;
                    }
                  }
                }
              }

              .box-segurado {
                display: flex;
                width: 100%;
                flex-direction: column;

                .caption {
                  margin: 0 0 1% 0;
                  color: #061d45;
                  font-size: 0.875rem !important;
                }

                .box-buttons-tipo {
                  display: flex;
                  justify-content: space-between;

                  .blue-button {
                    margin: 0;
                    padding: 0;
                    width: 48%;
                  }
                }

                .input-segurado {
                  margin: 2% 0 0 0;
                }

                .segurado-info {
                  margin: 0 0 2% 0;
                }
              }
              .box-combo-modalidades {
                overflow: hidden;

                .combo-modalidades {
                  white-space: nowrap;
                  text-overflow: clip;
                }
              }

              @media screen and (max-width: 830px) {
                .combo-modalidades {
                  margin: 8% 0 2% 0 !important;
                }

                .box-recursal {
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  align-items: center;

                  .valor-recurso,
                  .importancia-segurada,
                  .inicio-vigencia,
                  .prazo-dia,
                  .final-vigencia,
                  .prazo-ano {
                    width: 100%;
                    margin: 2% 0;
                  }

                  .importancia-segurada {
                    .msg_recursal {
                      width: 100%;
                      left: 0%;
                      bottom: 390px;
                    }
                  }
                }

                .box-segurado {
                  .box-buttons-tipo {
                    flex-direction: column;
                    .blue-button {
                      width: 100%;
                      margin-bottom: 4%;
                    }
                  }

                  .segurado-info {
                    margin: 0 0 4% 0;
                  }
                }
              }
              //Ajustes mensagem recursal
              @media screen and (max-width: 675px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 370px;
                    }
                  }
                }
              }
              @media screen and (max-width: 620px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 340px;
                    }
                  }
                }
              }
              @media screen and (max-width: 510px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 320px;
                    }
                  }
                }
              }
              @media screen and (max-width: 470px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 280px;
                    }
                  }
                }
              }
              @media screen and (max-width: 361px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 250px;
                    }
                  }
                }
              }
              @media screen and (max-width: 376px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 240px;
                    }
                  }
                }
              }
              @media screen and (max-width: 321px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 270px;
                    }
                  }
                }
              }
              @media screen and (max-width: 300px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 170px;
                    }
                  }
                }
              }
              @media screen and (max-width: 250px) {
                .box-recursal {
                  .importancia-segurada {
                    .msg_recursal {
                      bottom: 100px;
                    }
                  }
                }
              }
            }

            .form-proposta-2 {
              display: flex;
              width: 100%;
              flex-direction: column;

              .box-objeto {
                display: flex;
                width: 100%;
                margin: 2% 0;
                justify-content: space-between;

                .tags-input {
                  width: 32%;
                }
              }

              .box-objeto-full {
                display: flex;
                width: 100%;
                margin: 2% 0;
                justify-content: space-between;
                flex-direction: column;

                .tags-input-full {
                  width: 100%;
                  margin: 1% 0;
                }
              }

              @media screen and (max-width: 890px) {
                .box-objeto {
                  flex-direction: column;

                  .tags-input {
                    width: 100%;
                    margin: 2% 0;
                  }
                }
              }
            }
          }

          @media screen and (max-width: 830px) {
            .insured {
              margin-top: 4%;
            }
          }
        }

        .resumo-proposta {
          display: flex;
          width: 30%;
          background-color: #061d45;
          overflow: auto;
        }

        @media screen and (max-width: 890px) {
          .add-proposta {
            height: 70%;
          }
          .resumo-proposta {
            height: 30%;
          }
        }
      }

      @media screen and (max-width: 1060px) {
        .proposta {
          flex-direction: column;

          .add-proposta {
            width: 100%;
          }

          .resumo-proposta {
            width: 100%;
            margin-top: 4%;
            overflow: auto;
          }
        }
      }
    }
  }

  .content_body {
    padding: 20px 40px 30px 40px !important;
    background-color: white;

    .titulo-proposta {
      font-size: 1.5rem;
      color: #282498;
      text-shadow: 1px solid rgba(0, 0, 0, 0.26);
    }

    .info-proposta {
      color: $grayLightColor;
      margin: 0 0 2% 0;
      text-shadow: 1px solid rgba(0, 0, 0, 0.26);
    }
  }

  .container {
    padding: 0 !important;
  }

  .flex {
    padding: 0;
  }

  .white_background {
    padding-top: initial;
    margin-top: 30px;
    overflow: auto;
  }

  .white_background .pull-right {
    text-align: right;
  }

  .info-red {
    color: #d21a5e;
  }
  .p-rel {
    position: relative;
  }
  .custom-i {
    font-size: 1.125rem;
    cursor: pointer;
  }
  .bold {
    font-weight: bold;
  }
  .no-padding-top {
    padding-top: 0 !important;
  }
  .no-padding-bottom {
    padding-bottom: 0 !important;
  }
  .msg-tomador-container {
    width: 30%;
    background-color: #fff;
    position: absolute;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    right: 30px;
    top: 0px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;

      &.info-red {
        margin-bottom: 5px;
      }
    }
  }

  .proposta__footer {
    height: 12vh !important;
  }

  .jns-button {
    font-size: 1rem;
    text-transform: none;
  }

  .readonly_button {
    background: #dddddd !important;
    color: rgba(0, 0, 0, 0.26) !important;
    box-shadow: none !important;
    cursor: not-allowed;
  }

  .msg_cpf_segurado {
    width: 53%;
    background-color: #ccc;
    position: absolute;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    top: inherit;
    border-radius: 0.4em;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  @media screen and (max-width: 830px) {
    .msg_cpf_segurado {
      width: 100% !important;
    }
  }

  .msg_cpf_segurado:after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: #ccc;
    border-top: 0;
    margin-left: -10px;
    margin-top: -10px;
  }
}

.v-text-field__prefix {
  text-align: left !important;
  padding-left: 10px !important;
  padding-right: 0px !important;
}

/* Slider */
.v-slider__thumb-label,
.v-slider__thumb-label__container {
  position: static !important;
}

.v-slider__thumb {
  width: 0px !important;
  height: 0px !important;
  background: transparent;
}

.v-slider__thumb-label {
  width: 18px !important;
  height: 18px !important;
  span {
    top: 110%;
    position: relative;
    left: 90%;
    color: #282498;
    font-weight: bold;
  }
}

.v-slider__thumb-label span {
  display: none;
}

.inative-route {
  opacity: 0.5;
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/router/views/Home/Listar.vue